// returns screen size as 10=xs, 20=sm, 30=md, 40=lg
// eslint-disable-next-line consistent-return

const showNavMenu = () => {
  const showMenuBtn = document.getElementById('show-mobile-nav-bar');
  const closeMenuBtn = document.getElementById('close-mobile-nav-bar');
  const header = document.querySelector('header');
  const showSearchBtn = document.getElementById('show-search');
  const closeMobileSearch = document.getElementById('close-mobile-search');

  showMenuBtn.addEventListener('click', () => {
    header.classList.toggle('show-mobile-menu');
  });
  closeMenuBtn.addEventListener('click', () => {
    header.classList.toggle('show-mobile-menu');
  });

  showSearchBtn.addEventListener('click', () => {
    header.classList.toggle('show-search-field');
  });

  closeMobileSearch.addEventListener('click', () => {
    header.classList.toggle('show-search-field');
  });
};

showNavMenu();

// eslint-disable-next-line consistent-return
const resState = function () {
  const resStateElement = document.querySelector('.res-state');
  if (resStateElement) {
    const { width } = resStateElement.getBoundingClientRect();
    return width;
  }
};

function debouncer(func, timeout) {
  let timeoutID;
  const timeoutValue = timeout || 30;
  return function () {
    const scope = this;
    // eslint-disable-next-line prefer-rest-params
    const args = arguments;
    clearTimeout(timeoutID);
    timeoutID = setTimeout(function () {
      func.apply(scope, Array.prototype.slice.call(args));
    }, timeoutValue);
  };
}

const changeBG = function () {
  const list = document.querySelectorAll('.cBg');
  if (resState() === 10) {
    for (let i = 0; i < list.length; i++) {
      const url = list[i].getAttribute('data-xs');
      if (url !== null) {
        list[i].style.backgroundImage = `url('${url}')`;
      }
    }
  } else if (resState() === 20) {
    for (let i = 0; i < list.length; i++) {
      const url = list[i].getAttribute('data-sm');
      if (url !== null) {
        list[i].style.backgroundImage = `url('${url}')`;
      } else {
        list[i].style.backgroundImage = `url('${list[i].getAttribute('data-lg')}')`;
      }
    }
  } else if (resState() === 30) {
    for (let i = 0; i < list.length; i++) {
      const url = list[i].getAttribute('data-md');
      if (url !== null) {
        list[i].style.backgroundImage = `url('${url}')`;
      } else {
        list[i].style.backgroundImage = `url('${list[i].getAttribute('data-lg')}')`;
      }
    }
  } else {
    for (let i = 0; i < list.length; i++) {
      const url = list[i].getAttribute('data-lg');
      list[i].style.backgroundImage = `url('${url}')`;
    }
  }
};

const mobileCheck = function () {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a,
      ) ||
      // eslint-disable-next-line no-useless-escape
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4),
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

function flexBox() {
  const d = document;
  let c = ' ';
  const prefixFlex = 'flex -webkit-flex -ms-flexbox -moz-box -webkit-box'.split(' ');
  const elem = d.createElement('b');
  const mStyle = elem.style;
  try {
    for (let i = 0, len = prefixFlex.length; i < len; i++) {
      // eslint-disable-next-line no-cond-assign
      c += (mStyle.display = prefixFlex[i]) && mStyle.display !== prefixFlex[i] ? 'no-flex' : 'flex';
      i = len;
    }
  } catch (e) {
    c += 'no-flex';
  }

  const flexClass = `${c}box`.trim();
  document.documentElement.classList.add(flexClass);
}

// set breakpoint value
resState();

// change bg
changeBG();
flexBox();

// window resize event
window.addEventListener(
  'resize',
  debouncer(function () {
    resState();
    changeBG();
  }),
);

// check mobile
if (mobileCheck() === true) {
  document.documentElement.classList.add('mobile');
}

// HEADER BUTTONS/MENU
// document.querySelector('.menuBtn').addEventListener('click', (e) => {
//   e.stopPropagation();
//   document.querySelector('header').classList.add('menuShow');
//   document.querySelector('header').classList.remove('searchShow', 'countryShow');
//   document.querySelector('.searchBox').classList.replace('show-on-click', 'hide-on-click');
//   // document.querySelector('.countryBox')
//   //   .classList
//   //   .replace('show-on-click', 'hide-on-click');
// });

// document.querySelector('.menuCloseBtn').addEventListener('click', () => {
//   document.querySelector('header').classList.remove('menuShow');
// });

// SEARCH
// document.querySelector('.searchBtn').addEventListener('click', (e) => {
//   const header = document.querySelector('header');
//   const searchBox = document.querySelector('.searchBox');
//   // const countryBox = document.querySelector('.countryBox');

//   e.stopPropagation();
//   header.classList.toggle('searchShow');

//   if (searchBox.style.display === 'none' || searchBox.style.display === '') {
//     searchBox.style.display = 'block';
//   } else {
//     searchBox.style.display = 'none';
//   }

//   header.classList.remove('menuShow', 'countryShow');
//   // countryBox.style.display = 'none';
// });

// document.querySelector('.searchCloseBtn').addEventListener('click', () => {
//   document.querySelector('header').classList.remove('searchShow');
//   document.querySelector('.searchBox').classList.replace('show-on-click', 'hide-on-click');
// });

// COUNTRIES
// $('.flagBtn').click(function(e) {
//   e.stopPropagation();
//   $('header').toggleClass('countryShow');
//   $('header').removeClass('menuShow searchShow');
//   $('.countryBox').stop(true,true).fadeToggle(300);
//   $('.searchBox').fadeOut(300);
// });

// document.querySelector('.flagBtn').addEventListener('click', (e) => {
//   e.stopPropagation();
//   document.querySelector('header').toggle('countryShow');
//   document.querySelector('header').remove('menuShow', 'searchShow');
//   document.querySelector('.countryBox');
//   const countryBox = document.querySelector('.countryBox');
//   if (countryBox) {
//     countryBox.style.transition = 'none';
//     countryBox.style.display = (countryBox.style.display === 'none' || countryBox.style.display === '') ? 'block' : 'none';
//     countryBox.style.transition = '';
//   }
//   document.querySelector('.searchBox').replace('show-on-click', 'hide-on-click');
// });

// document.querySelector('.countryCloseBtn').addEventListener('click', () => {
//   document.querySelector('header').remove('countryShow');
//   document.querySelector('.countryBox').replace('show-on-click', 'hide-on-click');
// });

// const mainElement = document.querySelector('main');
// const footerElement = document.querySelector('footer');

// const clickHandler = () => {
//   document.querySelector('header').classList.remove('menuShow', 'searchShow', 'countryShow');
//   document.querySelector('.searchBox').classList.replace('show-on-click', 'hide-on-click');
//   // document.querySelector('.countryBox').classList.replace('show-on-click', 'hide-on-click');
// };

// mainElement.addEventListener('click', clickHandler);
// footerElement.addEventListener('click', clickHandler);

// HEADER BUTTONS/MENU

// START cookie policy

// if (!Cookies.get('cookiePolicy')) {
//   document.querySelector('.cookiePolicy').style.display = '';
// }

// document.querySelector('.cookiePolicy').style.display = '';

// document.querySelector('cookieBtn').addEventListener('click', () => {
//   // Cookies.set('cookiePolicy', 'enabled', { expires: 30 });
//   document.querySelector('cookiePolicy').style.display = 'none';
// });

// END cookie policy

/* video player */

// document.querySelector('.videoPlayBtn').addEventListener('click', (e) => {
//   e.preventDefault();
//   const element = e.currentTarget;
//   const player = element.parentElement.querySelector('.videoPlayer');
//   const youAttr = element.getAttribute('data-yt');
//   const htmlAttr = element.getAttribute('data-html');

//   if (youAttr) {
//     player.innerHTML = '<iframe src="https://www.youtube.com/embed/' + youAttr + '?rel=0&autoplay=1" frameborder="0" allowfullscreen></iframe>';
//     player.style.display = 'block';
//     debugger;
//   } else {
//     player.innerHTML = '<video controls autoplay><source src="/uploads/video/' + htmlAttr + '.mp4" type="video/mp4"><source src="/uploads/video/' + htmlAttr + '.webm" type="video/webm"><source src="/uploads/video/' + htmlAttr + '.ogv" type="video/ogv"></video>';
//     player.classList.replace('hide-on-click', 'show-on-click');
//   }
// });

// document.querySelector('.videoPlayerClose').addEventListener('click', (e) => {
//   e.preventDefault();
//   const element = e.currentTarget;
//   const player = element.parentElement;
//   const iframes = player.querySelectorAll('iframe');
//   const videos = player.querySelectorAll('video');

//   iframes.forEach(iframe => iframe.remove());
//   videos.forEach(video => video.remove());

//   player.classList.replace('show-on-click', 'hide-on-click');
// });

// START section animation

const offset = (el) => {
  const box = el.getBoundingClientRect();
  const docElem = document.documentElement;
  return {
    top: box.top + window.pageYOffset - docElem.clientTop,
    left: box.left + window.pageXOffset - docElem.clientLeft,
  };
};

// eslint-disable-next-line consistent-return
const scrollTop = (el, value) => {
  let win;
  if (el.window === el) {
    win = el;
  } else if (el.nodeType === 9) {
    win = el.defaultView;
  }

  if (value === undefined) {
    return win ? win.pageYOffset : el.scrollTop;
  }

  if (win) {
    win.scrollTo(win.pageXOffset, value);
  } else {
    el.scrollTop = value;
  }
};

const animationElements = document.querySelectorAll('.loadEffect');
const wrapperElement = document.querySelector('.wrapper');

const checkIfInView = () => {
  const windowHeight = document.documentElement.clientHeight;
  const windowTopPosition = scrollTop(window);
  const windowBottomPosition = windowTopPosition + windowHeight;

  animationElements.forEach((element) => {
    const elementHeight = element.offsetHeight;
    const elementTopPosition = offset(element).top + 100;
    const elementBottomPosition = elementTopPosition + elementHeight;
    if (elementBottomPosition >= windowTopPosition && elementTopPosition <= windowBottomPosition) {
      element.style.opacity = '1';
    } else {
      // element.classList.remove('in-view');
    }
  });
};

window.addEventListener('scroll', checkIfInView);
window.addEventListener('resize', checkIfInView);
wrapperElement.addEventListener('scroll', checkIfInView);
wrapperElement.addEventListener('resize', checkIfInView);
setTimeout(() => checkIfInView(), 1000);

// END section animation

// send information to pixel in click Where Buy

const whereBuyBtn = document.querySelectorAll('.btn_where_buy');
whereBuyBtn.forEach((button) => {
  button.addEventListener('click', () => {
    const buyP = {
      type: 'CONVERSION',
      /* config START */
      site_id: '7023',
      order: [],
      transaction_id: '',
      revenue: '',
      pixel_id: 'cesar_buy',
      /* config END */
    };
    // eslint-disable-next-line no-undef
    __GetI.push(buyP);
    // console.log('sender in pixel');
  });
});

const popupBtn = document.querySelectorAll('.popupShop');
popupBtn.forEach((button) => {
  button.addEventListener('click', () => {
    const title = button.getAttribute('data-name');
    if (title.length > 0) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'event',
        eventCategory: 'product',
        eventAction: title,
        eventLabel: 'dog_friendly',
      });
    }
    const buyP = {
      type: 'CONVERSION',
      /* config START */
      site_id: '7023',
      order: [],
      transaction_id: '',
      revenue: '',
      pixel_id: 'cesar_buy',
      /* config END */
    };
    // eslint-disable-next-line no-undef
    __GetI.push(buyP);
    // console.log('sender in pixel to click BUY in dog-friendly');
  });
});

const btnOnline = document.querySelectorAll('.btn_online');
btnOnline.forEach((button) => {
  button.addEventListener('click', () => {
    const buyP = {
      type: 'CONVERSION',
      /* config START */
      site_id: '7023',
      order: [],
      transaction_id: '',
      revenue: '',
      pixel_id: 'cesar_buy',
      /* config END */
    };
    // eslint-disable-next-line no-undef
    __GetI.push(buyP);
    // console.log('sender in pixel to click BUY in cart');
  });
});

const dogFriendlyMore = document.querySelectorAll('.dog_friendly_more');
dogFriendlyMore.forEach((button) => {
  button.addEventListener('click', () => {
    const cartP = {
      type: 'CONVERSION',
      /* config START */
      site_id: '7023',
      order: [],
      transaction_id: '',
      revenue: '',
      pixel_id: 'cesar_friend',
      /* config END */
    };
    // eslint-disable-next-line no-undef
    __GetI.push(cartP);
    // console.log('sender in pixel to click More in cart');
  });
});

const popupMoreCard = document.querySelectorAll('.popup_more_card');
popupMoreCard.forEach((button) => {
  button.addEventListener('click', () => {
    const cartP = {
      type: 'CONVERSION',
      /* config START */
      site_id: '7023',
      order: [],
      transaction_id: '',
      revenue: '',
      pixel_id: 'cesar_friend',
      /* config END */
    };
    // eslint-disable-next-line no-undef
    __GetI.push(cartP);
    // console.log('sender in pixel to click More in cart');
  });
});

const ownerInfo = document.querySelectorAll('.owner-info');
ownerInfo.forEach((button) => {
  button.addEventListener('click', (e) => {
    e.preventDefault();
    const element = e.currentTarget;
    element.classList.toggle('opened');
  });
});

function searchBar() {
  const { body } = document;
  if (resState() < 30) {
    body.classList.remove('searchPage');
  } else {
    body.classList.add('searchPage');
  }
}

async function getResult(query) {
  try {
    const request = await fetch(`/product/default/result/?query=${query}`);
    const response = await request.text();
    const searchResultContainer = document.querySelector('.resultContent');
    if (searchResultContainer) {
      searchResultContainer.innerHTML = response;
    }
  } catch (error) {
    console.error('An error occured in layout/getResult', error);
  }
}

// SEARCH REFACTORING IN VANILLA JS
// document.addEventListener('DOMContentLoaded', () => {
//   document.addEventListener('resize', () => {
//     debouncer(function () {
//       searchBar();
//     });
//   });

//   searchBar();

//   const query = document.getElementById('query');
//   const searchText = document.getElementById('searchtxt');
//   const searchQuery = document.getElementById('queryresulttxt');
//   if (searchText) {
//     searchText.value = query.value;
//   }
//   getResult(query.value);

//   searchText.addEventListener('keyup', (e) => {
//     const elem = e.target;
//     const queryText = e.target.value.replace(/[^a-zа-яёË1-9\s]/giu, '');
//     elem.value = queryText;
//     searchQuery.value = queryText;
//     getResult(queryText);
//   });
// });

$(document).ready(function () {
  $(window).resize(
    debouncer(function () {
      searchBar();
    }),
  );
  searchBar();
  const query = $('#query').val();
  $('#searchtxt').val(query);

  if (query) getResult(query);

  $('#searchtxt').keyup(function () {
    let querytxt = $(this).val();
    querytxt = querytxt.replace(/[^a-zа-яёË1-9\s]/giu, '');
    $(this).val(querytxt);
    $('#queryresulttxt').text(querytxt);
    getResult(querytxt);
  });
});
